import $ from 'jquery';
import {MARKET} from 'Utils/market.constants';


const CLASS = {
    LOGIN_NAMES: '.js-login-names'
}


const updateLoginBoxNamesLhs = function updateLoginBoxNamesLhs() {
    let scriptTag = document.getElementById("sas_user_info");
    if (scriptTag) {
        let userInfos = getUserInfos(scriptTag);
        if (userInfos !== null ) {
            if($(CLASS.LOGIN_NAMES).text() === "" && MARKET.CODE != 1) {
                $(CLASS.LOGIN_NAMES).append(getFormatedNames(userInfos));
            }
            return getFormatedNamesForSnackBar(userInfos);
        }
    }else {
        return "";
    }
};

function getUserInfos(scriptTag) {
    try {
        let userInfos = JSON.parse(scriptTag.innerHTML.trim());
        if (userInfos && userInfos["user-info-firstname"] && userInfos["user-info-lastname"]) {
            return {
                lastName: camelCase(userInfos["user-info-lastname"].toLowerCase()),
                firstName: userInfos["user-info-firstname"].substring(0,1),
                fullFirstName:camelCase (userInfos["user-info-firstname"].toLowerCase()),
                lastConnectionDate: new Date(getCookie("lastDate") * 1000)
            }
        } else {
            console.error("Impossible de récupérer les informations utilisateur");
            return null;
        }
    } catch(e) {
        console.error("Impossible de récupérer les informations utilisateur");
        return null
    }
}

function getFormatedNames(userInfos) {
    return `${(userInfos && userInfos.firstName) ? userInfos.firstName : ""}. ${(userInfos && userInfos.lastName) ? userInfos.lastName : ""}`;
}

function getFormatedNamesForSnackBar(userInfos) {
    return `${(userInfos && userInfos.fullFirstName) ? userInfos.fullFirstName : ""} ${(userInfos && userInfos.lastName) ? userInfos.lastName : ""}`;
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

// add/remove class polyfill
function addClass(element, className) {
    element.className += " " + className;
}

function removeClass(element, className) {
    element.className = element.className.replace(className, "");
}

function camelCase(str) {
    return str.toLowerCase().replace(/(^|[':.,; -])./g,function(e){
        return e.toUpperCase()
    });
}

export {updateLoginBoxNamesLhs};



// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/name.js